import { render, staticRenderFns } from "./DoctorCardActions.vue?vue&type=template&id=fa703eaa&"
import script from "./DoctorCardActions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardActions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa703eaa')) {
      api.createRecord('fa703eaa', component.options)
    } else {
      api.reload('fa703eaa', component.options)
    }
    module.hot.accept("./DoctorCardActions.vue?vue&type=template&id=fa703eaa&", function () {
      api.rerender('fa703eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardActions.vue"
export default component.exports